import type { IconProps } from '../create-icon'

// Official VALORANT Initiator role glyph (traced from Riot's role displayIcon).
// Filled disc with the symbol punched out as negative space — matches in-game art.
export function ValInitiator({
  size = 24,
  color = 'currentColor',
  className,
  style,
  ...rest
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 128 128"
      fill={color}
      className={className}
      style={style}
      {...rest}
    >
      <g transform="translate(0,128) scale(0.1,-0.1)">
        <path d="M650 1275 c0 -2 101 -167 225 -367 l225 -363 -256 -3 c-212 -2 -255 -5 -251 -16 5 -12 284 -465 292 -474 2 -2 32 11 67 29 97 52 205 165 257 269 94 192 94 388 0 580 -82 165 -252 297 -434 335 -69 15 -125 19 -125 10z M335 1202 c-198 -104 -335 -334 -335 -562 0 -237 141 -465 350 -569 89 -43 208 -74 270 -69 l37 3 -233 375 -233 375 258 5 258 5 -146 237 c-80 131 -148 237 -151 237 -3 0 -36 -16 -75 -37z" />
      </g>
    </svg>
  )
}
